export const PARAM_TIMEFRAME = 'tf';
export const PARAM_DATE = 'd';
export const PARAM_SIDEBAR = 'sb';

export const DATE_FORMAT = 'y-MM-dd';
export const ADHERENCE_BEGINNING_OF_TIME = '2020-01-05';
